import { Modal } from "antd-mobile";
import { useIntl } from "react-intl";
import styled from "styled-components";
export default function useComposingModal() {
  const intl = useIntl()
  const show = ({onConfrim=() => {}}) => {

    return Modal.show({
      title: intl.formatMessage({id:'components.compose_modal.title',defaultMessage:"裝備合成"}),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "1",
          className: "border_btn",
          text: intl.formatMessage({id:'common.back',defaultMessage:"返回"}),
        },
        {
          key: "2",
          className: "primary_btn",
          text: intl.formatMessage({id:'components.compose_modal.toBag',defaultMessage:"去背包"}),
          primary: true,
        },
      ],
      onAction: (action, index) => {
        onConfrim(action)
      },
      closeOnAction: false,
      content: <ComposingModal intl={intl} />,
    });
  };
  return {
    show,
  };
}

function ComposingModal({ intl }) {
  return (
    <div className="text-center">
      <Detail>{ intl.formatMessage({id:'components.compose_modal.waiting',defaultMessage:"合成中…請稍後到背包查看"})}</Detail>
    </div>
  );
}

const Detail = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.6rem;

  color: #000000;

  margin: 2.0rem auto;
`;
